import type React from 'react';

/**
 * Semantic typography variants mapping to canonical design tokens.
 * Each entry resolves fontSize + fontWeight from the token scale defined
 * in tokens-typography.css. Used by the Text component to provide a
 * token-backed API that prevents raw utility class drift.
 */
export const SEMANTIC_VARIANTS: Record<string, React.CSSProperties> = {
  pageTitle: { fontSize: 'var(--text-app-title)', fontWeight: 'var(--font-bold)' as any },
  section: { fontSize: 'var(--text-app-section)', fontWeight: 'var(--font-semibold)' as any },
  heading: { fontSize: 'var(--text-app-heading)', fontWeight: 'var(--font-semibold)' as any },
  subheading: { fontSize: 'var(--text-app-subheading)', fontWeight: 'var(--font-medium)' as any },
  body: { fontSize: 'var(--text-body)' },
  bodyLg: { fontSize: 'var(--text-body-lg)' },
  bodySm: { fontSize: 'var(--text-body-sm)' },
  small: { fontSize: 'var(--text-small)' },
  meta: { fontSize: 'var(--text-meta)' },
  micro: { fontSize: 'var(--text-micro)' },
};

/**
 * Tone-to-color-token mapping. Resolves the tone prop to a CSS color
 * variable, letting callers avoid writing raw text-[var(--text-*)] utilities.
 */
export const TONE_MAP: Record<string, string> = {
  primary: 'var(--text-primary)',
  secondary: 'var(--text-secondary)',
  tertiary: 'var(--text-tertiary)',
  inverse: 'var(--text-inverse)',
};

/**
 * Legacy variant classes (Mantine-compat shim). These use Tailwind classes
 * and remain for backward compatibility with existing consumers.
 */
export const LEGACY_VARIANT_CLASSES: Record<string, string> = {
  title: 'text-lg font-semibold',
  caption: 'text-sm text-[var(--text-secondary)]',
  label: 'text-sm font-medium',
  empty: '',
};

/**
 * Legacy size → Tailwind class mapping (Mantine-compat shim).
 */
export const LEGACY_SIZE_CLASSES: Record<string, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
};
